import React, { useEffect, useReducer, useRef, useState } from "react";
import { Link, useRouteMatch } from "react-router-dom";

import { Icon, Row, Table, Typography, Upload, Tag, Popover, Button } from "antd";

import "./multiCountry.scss";
import Loader from "components/Loader/Loader";

import { fetchCountryListApi } from "utils/apiService";
import ReactCountryFlag from "react-country-flag";
// import { getCountryFlag } from "views/stores-management/StoresTable";

import { countries } from "constants/CountryList";

const getCountryFlag = (countryName) => {
    var countryCode = countries.find((data) => data.name === countryName).shortName;
    return countryCode;
};
const { Text } = Typography;

const CountryListTable = (props) => {
    const countryInfo = props.data.countries.filter((country) => country.short_name === JSON.parse(localStorage.getItem("countryData"))?.short_name)
    const countryObject = countryInfo[0]?.languages.map((language) => {
        return {
            ...countryInfo[0],
            language: language
        }
    }
    )
    const columns = [
        {
            title: "Country Name",
            dataIndex: ["country_name", "short_name"],
            key: "country",
            render: (_, data) => {
                // const countryCode = getCountryFlag(false || "United Arab Emirates");
                // console.log(data);
                return (
                    <div>
                        <ReactCountryFlag
                            countryCode={data.short_name}
                            svg
                            title={data.country_name}
                            style={{
                                height: "23px",
                                width: "23px",
                                borderRadius: "20px",
                                backgroundColor: "black",
                                objectFit: "cover",
                                marginRight: "10px",
                            }}
                        />
                        <Text
                            style={{
                                fontStyle: "normal",
                                fontWeight: "bold",
                                fontSize: "16px",
                                lineHeight: "24px",
                                color: "#181818",
                                whiteSpace: "nowrap",
                            }}>
                            {data.country_name ? data.country_name : "UAE"}
                        </Text>
                    </div>
                );
            },
        },

        {
            title: "Language",
            dataIndex: "language",
            key: "language",
            render: (data) => {
                return (
                    <div style={{ display: "flex", width: "25%" }}>
                        {/* {data.map((x) => */}
                        <Tag
                            style={{
                                border: `1px solid ${data ? "#B7EB8F" : "#D9D9D9"}`,
                                height: "23px",
                            }}>
                            {/* <Icon
                                    type={data ? "check-circle" : "info-circle"}
                                    //   theme="twoTone"
                                    style={{
                                        padding: "2px",
                                        color: `${data !== true ? "#181818" : "#2A9C0A"}`,
                                    }}
                                /> */}
                            <Text
                                style={{
                                    fontSize: "12px",
                                    lineHeight: "20px",
                                    color: `${data !== true ? "#181818" : "#2A9C0A"}`,
                                    padding: "2px",
                                    marginLeft: "2px",
                                }}>
                                {data}
                            </Text>
                        </Tag>
                        {/* )} */}
                    </div>
                );
            },
        },
        // {
        //     title: "Stores",
        //     dataIndex: "store_count",
        //     key: "stores",
        //     render: (data) => {
        //         return (
        //             <Text
        //                 style={{
        //                     fontStyle: "normal",
        //                     fontWeight: "bold",
        //                     fontSize: "16px",
        //                     lineHeight: "24px",
        //                     color: "#181818",
        //                     whiteSpace: "nowrap",
        //                     width: "30%",
        //                 }}>
        //                 {data || "0"}
        //             </Text>
        //         );
        //     },
        // },
        // {
        //     title: "Currency",
        //     dataIndex: "currency",
        //     key: "currency",
        //     render: (data) => {
        //         return (
        //             <Text
        //                 style={{
        //                     fontStyle: "normal",
        //                     fontWeight: "bold",
        //                     fontSize: "16px",
        //                     lineHeight: "24px",
        //                     color: "#181818",
        //                     whiteSpace: "nowrap",
        //                     width: "30%",
        //                 }}>
        //                 {data ? data : "AED"}
        //             </Text>
        //         );
        //     },
        // },

        {
            title: "",
            dataIndex: "database_identifier",
            key: "isd_code",
            render: (data) => (
                <Link to={`countries/${data}`}>
                    <Icon type="right" theme="outlined" style={{ color: "#D1D1D1" }} />
                </Link>
            ),
        },
    ];

    return (
        <>
            <Table
                // rowSelection={props.noAction ? null : rowSelection}
                columns={(function () {
                    // if (props.noAction) {
                    // 	return columns.filter((item) => item.key != "x");
                    // }
                    return columns;
                })()}
                // dataSource={countryInfo[0]?.languages}
                dataSource={countryObject}
                pagination={{ showQuickJumper: true, pageSize: 10 }}
                style={{ overflow: "none" }}
                loading={props.loading}
                onRow={(record) => {
                    return {
                        onClick: () => {
                            props.history.push(`/countryInfo/${record.database_identifier}/${record.language}`);
                        },
                    };
                }}
            />
        </>
    );
};

const CountryInfo = (props) => {
    const [loading, setLoading] = useState(true);
    const [tableLoading, setTableLoading] = useState(true);

    const [countryList, setCountryList] = useState({
        countries: [],
        pageNum: 1,
        pageSize: 10,
        totalPages: 1,
    });

    const loadTable = () => {
        setTableLoading(true);
        fetchCountryListApi({
            requestData: {},
            resCallback: () => {
                loading && setLoading(false);
                setTableLoading(false);
            },
            res200Callback: (res) => {
                setCountryList({
                    ...countryList,
                    countries: res.data.country_list,
                });
            },
        });
    };

    useEffect(() => {
        loadTable();
    }, []);

    return loading ? (
        <Row type="flex" align="middle" justify="center" style={{ marginTop: "200px" }}>
            <Loader />
        </Row>
    ) : (
        <Row
            style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                padding: "40px 25px 70px",
                margin: "60px auto 20px",
                backgroundColor: "#FAFAFA",
                marginTop: "80px",
            }}
            gutter={[12, 48]}>
            <Row
                type="flex"
                align="middle"
                justify="space-between"
                style={{
                    marginBottom: "24px",
                }}>
                <Text
                    style={{
                        color: "#181818",
						/*fontFamily: "Gotham",*/ fontStyle: "normal",
                        fontWeight: "bold",
                        fontSize: "24px",
                        lineHeight: "39px",
                    }}>
                    Countries
                </Text>
            </Row>
            <CountryListTable {...props} loading={tableLoading} data={countryList} />
        </Row>
    );
};

export default CountryInfo;
